import { render, staticRenderFns } from "./myhead.vue?vue&type=template&id=21292fd2&scoped=true&"
import script from "./myhead.vue?vue&type=script&lang=js&"
export * from "./myhead.vue?vue&type=script&lang=js&"
import style0 from "./myhead.vue?vue&type=style&index=0&id=21292fd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21292fd2",
  null
  
)

export default component.exports